import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { CheckboxField } from 'Shared/form/CheckboxField';
import { DatePickerField } from 'Shared/form/DatePickerField';
import withFormikFields from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from './CommonPatientFieldWrapper';
import SectionTitleStyle from './SectionTitleStyle';

const WelcomePacketForm = ({ fieldValues: { welcomePacket, welcomePacketReturned, welcomePacketSent } }) => {
    return (
        <CommonPatientFieldWrapper fieldName="welcomePacket">
            {(commonProps) => (
                <div>
                    <SectionTitleStyle>
                        <h2>Welcome Packet</h2>
                    </SectionTitleStyle>

                    <CheckboxField
                        fieldName="welcomePacket"
                        label="Welcome packet requested"
                        disabled={commonProps.disabled}
                    />

                    {welcomePacket && (
                        <Row>
                            <Col md={6}>
                                <DatePickerField
                                    fieldName="welcomePacketSent"
                                    label="Mail Date"
                                    required
                                    maxDate={welcomePacketReturned}
                                    disabled={commonProps.disabled}
                                />
                            </Col>
                            <Col md={6}>
                                <DatePickerField
                                    fieldName="welcomePacketReturned"
                                    label="Return Date"
                                    minDate={welcomePacketSent}
                                    disabled={commonProps.disabled}
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            )}
        </CommonPatientFieldWrapper>
    );
};

WelcomePacketForm.propTypes = {
    fieldValues: PropTypes.shape({
        welcomePacket: PropTypes.bool,
        welcomePacketReturned: PropTypes.instanceOf(Date),
        welcomePacketSent: PropTypes.instanceOf(Date),
    }).isRequired,
};

export default withFormikFields({
    WrappedComponent: WelcomePacketForm,
    fieldNames: ['welcomePacket', 'welcomePacketReturned', 'welcomePacketSent'],
});
